import App from '@/app'

const counterUpObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		if (entry.isIntersecting) {
			entry.target.animate()

			counterUpObserver.unobserve(entry.target)
		}
	})
}, {
	root: null,
	threshold: [ .1,.2,.3,.4,.5,.6,.7,.8,.9,1 ]
})

App.directive('counterup', /**
* @param { HTMLElement } el - Elemento com a diretiva [v-coubterup]
* @param { Object } binding - Objeto de options da diretiva
* @exemple
* <div v-counterup="{
* 	from: 0, to: 25.5, decimal: 1,
* }">0</div>
*
*/(el, binding) => {
	// Ponto de Partida
	const from      = binding.value.from     || 0
	const to        = binding.value.to       || 1000
	const preffix   = binding.value.preffix  || ''
	const suffix    = binding.value.suffix   || ''
	const duration  = binding.value.duration || 2000

	// Money
	const money    = binding.value.money    || null
	const currency = binding.value.currency || 'USD'
	const locale   = binding.value.locale   || 'en'

	// Casas depois da vírgula
	const decimal   = binding.value.decimal  || null

	const animate = () => {
		let startTime   = null
		let currentTime = Date.now()
		let connection;

		const step = (currentTime) => {

			// Checking startTime
			if (startTime === null) startTime = currentTime

			// Calculate the progress
			const progress = Math.min(
				( currentTime - startTime) / duration,
				1
			)
			let currentValue;

			if(decimal) {
				currentValue = (progress * (to - from)) + from
				currentValue = currentValue.toFixed(decimal)

				if(money) {
					currentValue = Number(currentValue)
					currentValue = new Intl.NumberFormat(locale, {
						style: 'currency',
						currency
					}).format(currentValue)
				}
			} else {

				currentValue = Math.floor(
					progress * (to - from) + from
				)

			}

			el.innerHTML = `${preffix}${currentValue}${suffix}`

			if (progress >= 1) return cancelAnimationFrame(connection)

			connection = requestAnimationFrame(step)
		}

		connection = requestAnimationFrame(step)
	}

	el.animate = animate

	counterUpObserver.observe(el)
})
